import { createSlice } from "@reduxjs/toolkit";
/* eslint-disable no-param-reassign */
const initialState = {
  AssigneeList: [],
  TeamsList: [],
  ClientsList: [],
  CustomersList: [],
};

export const AssignneTeamDropdownSlice = createSlice({
  name: "DropdownList",
  initialState,
  reducers: {
    setAssigneeList: (state, action) => {
      state.AssigneeList = action.payload;
    },

    setTeamsList: (state, action) => {
      state.TeamsList = action.payload;
    },

    setlClientsList: (state, action) => {
      state.ClientsList = action.payload;
    },

    setlCustomersList: (state, action) => {
      state.CustomersList = action.payload;
    },

    clear: () => initialState,
  },
});

export const {
  setAssigneeList,
  setTeamsList,
  setlClientsList,
  setlCustomersList,
  clear,
} = AssignneTeamDropdownSlice.actions;

export default AssignneTeamDropdownSlice.reducer;
